import regularTasksApi from '@/api/regularTasks';

const state = {
  regularTasks: [],
  regularTask: {},
  filteredRegularTasks: [],
};

export const actions = {
  getList({ dispatch, commit }) {
    regularTasksApi.getRegularTasks().then((data) => {
      dispatch('setRegularTasks', data);
      commit('regularTask', data.regularTasks);
    });
  },

  get({ commit }, arg) {
    regularTasksApi.getRegularTask(arg).then((data) => {
      commit('regularTask', data.regularTask);
    });
  },

  getListByProject({ commit }, arg) {
    regularTasksApi.getListByProject(arg).then((data) => {
      commit('filteredRegularTasks', data.regularTasks);
      //commit('regularTask', data.regularTasks);
    });
  },
  getListByRequirement({ commit }, arg) {
    regularTasksApi.getListByRequirement(arg).then((data) => {
      commit('filteredRegularTasks', data.regularTasks);
      //commit('regularTask', data.regularTasks);
    });
  },
  search({ commit }, arg) {
    regularTasksApi.searchRegularTask(arg).then((data) => {
      commit('regularTasks', data.regularTasks);
    });
  },

  //Ajout des champs pour modifier les données directement dans la table
  setRegularTasks({ commit }, args) {
    let regularTasks = args.regularTasks.map(x => {
      x.disabled = true;
      x.oldValue = {};
      return x;
    })
    commit('regularTasks', regularTasks);
  },

  save({ commit, dispatch }, args) {

  //   public Guid RegularTaskGuid { get; set; }
  //   public Guid TypeGuid { get; set; }
  //   public string Name { get; set; }
  //   public decimal EstimatedHours { get; set; }
  //   public decimal TimeMax { get; set; }
  //   public decimal TimeMin { get; set; }
  //   public decimal? Multiplicator { get; set; }
  //   public Guid RelatedProjectRegularTaskGuid { get; set; }
	// public int? ProjectRegularTaskId { get; set; }
  //   public bool IsActive { get; set; }
  //args.regularTask.isActive = false;
  //args.regularTask.multiplicator = null;
  //args.regularTask.projectRegularTaskId = null;
    regularTasksApi.saveRegularTask(args).then((data) => {
      regularTasksApi.getRegularTasks().then((data) => {
        dispatch('setRegularTasks', data);
        commit(
          'alert/add',
          {
            title: 'Informations',
            message: 'La tâche été modifiée avec succès!',
            variant: 'success',
            icon: 'check_circle',
          },
          { root: true },
        );
      })
    });
  },

  delete({ dispatch }, args) {
    regularTasksApi.deleteRegularTask(args).then(() => {
      dispatch('getList');
    });
  },
};
export const mutations = {
  regularTasks(state, payload) {
    state.regularTasks = payload;
  },
  regularTask(state, payload) {
    state.regularTask = payload;
  },
  filteredRegularTasks(state, payload) {
    state.filteredRegularTasks = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
